/* The job's checklist (piece 29; T389): one row per item, its answer or its
   controls beneath the title, wrapping onto lines of their own at phone width.
   Every value a token. */
.checklist {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.items {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--surface-2);
  min-width: 0;
}

/* 🔒 Decision 12580: a checklist's heading with Open Work Instruction beside it, wrapping under it at phone width. */
.groupLine {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-2);
}

.group {
  margin: 0 0 var(--space-1);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-2);
}

.itemTitle {
  font-weight: var(--font-weight-semibold);
  overflow-wrap: anywhere;
}

.kind,
.hint {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-small);
  line-height: var(--line-height-base);
  overflow-wrap: anywhere;
}

.answer,
.controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-2);
}

.value {
  font-weight: var(--font-weight-semibold);
  overflow-wrap: anywhere;
}

.flag {
  font-weight: var(--font-weight-semibold);
  color: var(--status-error-text);
  overflow-wrap: anywhere;
}

.problem {
  margin: 0;
  color: var(--status-error-text);
  font-size: var(--font-size-small);
}

/* Decision 2280: the cited procedure under the item's title, its title a link
   and Open Procedure beside it, wrapping on a phone. */
.procedure {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2);
  min-width: 0;
}

.procedureLink {
  color: var(--navy-primary);
  font-weight: var(--font-weight-semibold);
  overflow-wrap: anywhere;
}

/* The signature pad takes the window's whole width, the full-width pad the phone flow names. */
.pad {
  width: 100%;
}

/* The camera's own input, opened by the item's button and never drawn. */
.file {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
